"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var _toggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var ToggleMenuFlyout = _toggleMenuFlyout;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useDebounce = require("use-debounce");
var _constants = require("../../constants");
var _context = require("../../context");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _SearchPreviewContainer = require("./components/SearchPreviewContainer");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SCROLL_THRESHOLD = _presentationUtils.SEARCH_INPUT_HEIGHT + 5;
const SearchInput = ({
  showOnlyOn
}) => {
  const {
    showSearchOnScroll
  } = (0, _context.useAppConfig)();
  const {
    visible: isTopBannerVisible
  } = (0, _context.useTopAreaBanner)();
  const {
    activeMenu,
    hideSearchResultsTab,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const {
    hide,
    show,
    isVisible,
    focus,
    blur,
    clearResults,
    value,
    isManuallyOpened,
    setValue,
    manualHide,
    isFocused,
    debouncedValue
  } = (0, _navigation.useSearchInput)();
  const isMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.SearchResults;
  const isAccountSideMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.AccountSideMenu;
  const isMobile = (0, _hooks.useIsMobile)();
  const inputRef = (0, _react.useRef)(null);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const [prevScrollY, setPrevScrollY] = (0, _react.useState)(0);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  (0, _utils2.useRemoveBodyScroll)(isMenuActive && isMobile);
  const throttledAnalytics = (0, _useDebounce.useThrottledCallback)(() => UserAction.dispatch(_constants.START_SEARCH), _constants.SEARCH_THROTTLE_TIME);
  const onFocusHandler = (0, _react.useCallback)(() => {
    focus();
  }, [focus]);
  const showBackdrop = (0, _utils2.shouldShowBackdrop)({
    isFocused,
    isMenuActive,
    isMobile
  });
  const onChangeHandler = (0, _react.useCallback)(({
    target
  }) => {
    const isValueEmpty = target.value.length === 0;
    if (isValueEmpty) {
      toggleActiveMenu('');
      clearResults();
    }
    setValue(target.value);
    throttledAnalytics();
    if (!isValueEmpty && !isMenuActive) {
      (0, _utils.dispatchToggleMenu)(ToggleMenuFlyout.MenuTypes.SearchResults);
    }
  }, [setValue, throttledAnalytics, isMenuActive, toggleActiveMenu, clearResults]);
  (0, _react.useEffect)(() => {
    const showWithoutFocus = () => {
      show();
      blur();
    };
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const difference = currentScrollY - prevScrollY;
      if (difference > SCROLL_THRESHOLD && isMobile && !isManuallyOpened && !isAccountSideMenuActive) {
        hide();
        hideSearchResultsTab();
      } else if (difference < -SCROLL_THRESHOLD && isMobile && !isAccountSideMenuActive) {
        showWithoutFocus();
      }
      setPrevScrollY(currentScrollY);
    };
    const handleScrollDebounced = (0, _mui.debounce)(handleScroll, 50);
    if (showSearchOnScroll) {
      window.addEventListener('scroll', handleScrollDebounced);
    }
    return () => window.removeEventListener('scroll', handleScrollDebounced);
  }, [isMobile, show, hide, blur, hideSearchResultsTab, isManuallyOpened, prevScrollY, showSearchOnScroll, isAccountSideMenuActive]);
  const closeSearch = (0, _react.useCallback)(() => {
    manualHide();
    hide();
    hideSearchResultsTab();
  }, [hide, hideSearchResultsTab, manualHide]);
  const clearInput = (0, _react.useCallback)(() => {
    setValue('');
    clearResults();
    toggleActiveMenu(_toggleMenuFlyout.MenuTypes.SearchInput);
    blur();
  }, [blur, clearResults, setValue, toggleActiveMenu]);
  const handleOnBlur = (0, _react.useCallback)(() => {
    if (!value) {
      blur();
    }
  }, [blur, value]);
  (0, _presentationHooks.useListenToKeyDown)(['Escape'], () => {
    if (isFocused) {
      inputRef.current?.blur();
      handleOnBlur();
      closeSearch();
    }
  });
  const isVisibleOnMobile = showOnlyOn === 'mobile' && isVisible;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchInputRoot, {
    isTopBannerVisible: isTopBannerVisible,
    isVisibleOnMobile: isVisibleOnMobile,
    showSearchOnScroll: showSearchOnScroll,
    showOnlyOn: showOnlyOn,
    isFocused: isFocused,
    "data-testid": getTestId(showOnlyOn === 'mobile' ? _constants2.SEARCH_INPUT_ROOT_MOBILE : _constants2.SEARCH_INPUT_ROOT_DESKTOP),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchInputBox, {
        "data-testid": getTestId(_constants2.SEARCH_INPUT_BOX),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Search, {
          fontSize: "medium",
          "data-testid": getTestId(_constants2.SEARCH)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputInput, {
          ref: inputRef,
          autoFocus: isManuallyOpened,
          type: "text",
          placeholder: translations.searchDesktop,
          value: value,
          "aria-label": translations.search,
          "data-testid": getTestId(_constants2.SEARCH_INPUT),
          id: "main-search",
          onFocus: onFocusHandler,
          onChange: onChangeHandler,
          onBlur: handleOnBlur,
          onKeyDown: _utils2.onEnterPressHandler
        }), value ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputClear, {
          disableRipple: true,
          "aria-label": translations.clearSearchInput,
          "data-testid": getTestId(_constants2.SEARCH_INPUT_CLEAR),
          isFocused: isFocused,
          onClick: clearInput,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
            fontSize: "inherit"
          })
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewContainer.SearchPreviewContainer, {
        query: debouncedValue
      })]
    }), showBackdrop ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InputBackdrop, {
      open: true,
      "data-testid": getTestId(_constants2.BACKDROP),
      onClick: closeSearch
    }) : null]
  });
};
exports.SearchInput = SearchInput;
